const isBeta = () => {
  return import.meta.env.VITE_ENV === 'beta';
};

export const isProduction = () => {
  return import.meta.env.VITE_ENV === 'production';
};

const gmrv = () => {
  if (isProduction() || isBeta()) {
    return [231, 525, 315, 233, 314, 313, 327, 833];
  }

  return [511, 822];
};

const cardinalCourier = () => {
  if (isProduction() || isBeta()) {
    return [682, 374, 1157];
  }

  return [984, 614, 1157];
};

const motiveFleets = () => {
  if (isProduction() || isBeta()) {
    return [1194];
  }
  //Just Cardinal on staging as a test
  return [614];
};

const algoInsightsFleets = () => {
  if (isProduction() || isBeta()) {
    return [1147, 1184];
  }

  return [614];
};

const roiReportFleets = () => {
  if (isProduction() || isBeta()) {
    return [374, 730, 665];
  }

  return [614];
};

const isMultipleTrips = () => {
  if (isProduction() || isBeta()) return [668, 226];

  return [822];
};

const npl = () => {
  if (isProduction() || isBeta()) return [395];

  return [700];
};

const wolfline = () => {
  if (isProduction() || isBeta()) return [933];

  return [];
};

const bmc = () => {
  if (isProduction() || isBeta()) return [1074];

  return [];
};

const renzi = () => {
  if (isProduction() || isBeta()) return [924];

  return [614];
};

const summitMaterials = () => {
  if (isProduction() || isBeta()) return [1259, 1260, 1261, 1262, 1263, 1264];

  return [];
};

const summitMaterialsRKHallSubFleets = () => {
  if (isProduction() || isBeta()) return { 1260: [1261, 1262, 1263, 1264] };
  return [];
};

const summitMaterialsWestSubFleets = () => {
  if (isProduction() || isBeta()) return { 1361: [1429, 1430] };
  return [];
};

const summitMaterialsMainFleets = () => {
  if (isProduction() || isBeta()) return [1259, 1260, 1361, 1552, 931]; // 931 include just for testing

  return [];
};

const summitMaterialsWest = () => {
  if (isProduction() || isBeta()) return [1361, 1429, 1430];

  return [];
};

const summitMaterialsFulton = () => {
  if (isProduction() || isBeta()) return [1552];

  return [];
};

const summitMaterialsAll = () => {
  return [
    ...summitMaterials(),
    ...summitMaterialsWest(),
    ...summitMaterialsFulton(),
  ];
};

const samsaraMainFleets = () => {
  if (isProduction() || isBeta())
    return [931, 1222, 1241, 1259, 1260, 1294, 1460, 1463, 1468, 1552];

  return [];
};

const cityOfWestJordan = () => {
  if (isProduction() || isBeta()) return [1184];

  return [];
};

const foxAndJames = () => {
  if (isProduction() || isBeta())
    return [1147, 1163, 1164, 1165, 1166, 1167, 1168];

  return [];
};

const goBolt = () => {
  if (isProduction() || isBeta()) return [1567];

  return [];
};

const foodExpress = () => {
  if (isProduction() || isBeta())
    return [1251, 1250, 1252, 1241, 1245, 1247, 1249, 1246, 1253];

  return [];
};

const ufpFleet = () => {
  console.log('environment:', import.meta.env.VITE_ENV);
  if (isProduction() || isBeta())
    return [
      1283, 1460, 1472, 1473, 1474, 1475, 1476, 1477, 1478, 1494, 2109, 2110,
      2112, 2113, 2114, 2115, 2170, 2335, 2338, 2339, 2340, 2341, 2342, 2343,
      2344, 2347, 2370, 2371,
    ];

  // 1157 = Wright Beverage Test Data on staging
  return [1283, 1460, 1157];
};

const pfgFleet = () => {
  if (isProduction() || isBeta())
    return [
      2183, 2305, 2306, 2334, 2193, 2194, 2192, 2288, 2196, 2292, 2198, 2297,
      2195, 2304, 2197,
    ];

  return [];
};

const tantara = () => {
  if (isProduction() || isBeta()) return [1222];

  return [];
};

const jitc = () => {
  if (isProduction() || isBeta()) return [1463, 374]; // 374 - Perfect Fleet for tests

  //inspection form testing for staging
  return [1818];
};

const geotabFleet = () => {
  if (isProduction() || isBeta())
    return [2126, 1085, 2050, 2173, 2174, 2183, 2172, 1359, 1147];

  return [];
};

const georgiapower = () => {
  if (isProduction() || isBeta()) return [2126];

  return [];
};

const timhortons = () => {
  if (isProduction() || isBeta())
    return [1369, 1527, 1562, 1471, 1885, 1937, 1528, 2145];

  return [];
};

const searportIntermodal = () => {
  if (isProduction() || isBeta()) return [1283, 1157, 374];

  return [1157];
};

const foodExpressVancouver = () => {
  if (isProduction() || isBeta()) return [1245];

  return [1245];
};

const customFleets = {
  gmrv: gmrv(),
  cardinalCourier: cardinalCourier(),
  roiReportFleets: roiReportFleets(),
  foodExpressVancouver: foodExpressVancouver(),
  isMultipleTrips: isMultipleTrips(),
  npl: npl(),
  wolfline: wolfline(),
  bmc: bmc(),
  renzi: renzi(),
  summitMaterials: summitMaterials(),
  summitMaterialsWest: summitMaterialsWest(),
  summitMaterialsFulton: summitMaterialsFulton(),
  summitMaterialsAll: summitMaterialsAll(),
  samsaraMainFleets: samsaraMainFleets(),
  summitMaterialsMainFleets: summitMaterialsMainFleets(),
  summitMaterialsRKHallSubFleets: summitMaterialsRKHallSubFleets(),
  summitMaterialsWestSubFleets: summitMaterialsWestSubFleets(),
  foodExpress: foodExpress(),
  ufpFleet: ufpFleet(),
  pfgFleet: pfgFleet(),
  tantara: tantara(),
  searportIntermodal: searportIntermodal(),
  cityOfWestJordan: cityOfWestJordan(),
  foxAndJames: foxAndJames(),
  motiveFleets: motiveFleets(),
  geotabFleet: geotabFleet(),
  georgiapower: georgiapower(),
  timhortons: timhortons(),
  algoInsightsFleets: algoInsightsFleets(),
  goBolt: goBolt(),
  jitc: jitc(),
};

export default customFleets;
